module.exports = __webpack_public_path__ + "assets/boluo.12599b48.svg";